import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SchoolProfilePage from './SchoolProfilePage';
import SchoolProfileNotFound from './SchoolProfileNotFound';
import { isReservedPath, normalizePublicPath } from '../../utils/reservedPaths';

/**
 * Route guard for root-level paths (e.g. /queens-school).
 *
 * Paths owned by the main website or platform never hit the school profile API
 * and fall through to the website's page-not-found experience.
 */
const SchoolProfileRoute = () => {
  const { publicPath: rawPublicPath } = useParams();
  const publicPath = normalizePublicPath(rawPublicPath);
  const navigate = useNavigate();

  // Routing stays in the route component: SchoolProfilePage takes a callback so
  // it never imports the router itself.
  const goToAdmissionForm = useCallback(() => {
    navigate(`/${publicPath}/admission`);
  }, [navigate, publicPath]);

  if (isReservedPath(publicPath)) {
    return <SchoolProfileNotFound variant="page" />;
  }

  // Remount on path change so each school loads with fresh state.
  return (
    <SchoolProfilePage
      key={publicPath}
      publicPath={publicPath}
      onApplyForAdmission={goToAdmissionForm}
    />
  );
};

export default SchoolProfileRoute;
